// extracted by mini-css-extract-plugin
export default {"footer_container":"Footer_footer_container__y6tpA","right_footer":"Footer_right_footer__27DaW"};